import {
  GET_RAFFLE_PRODUCTS,
  PROMISE_PENDING,
  PROMISE_REJECTED,
  PROMISE_FULFILLED,
} from '../constants';
import parseError from '../utils/error';

const initialState = {
  raffleProducts: {
    data: [],
    isFetch: false,
    error:null,
    status_code: 0
  }
}
const getTypeError = err => {
  switch(err.status_code){
    case 404 : return "NOT_FOUND_ERR";
    case "403" : return "FORBIDDEN_ERR";
    case 500 : {
      if(err.message == 'User has already entered this raffle')
        return "ALREADY_SUBMIT_ERR";
    };
    case 422 : return "VALIDATION_FORM_ERR"
    default: return "UNKNOWN_ERR"
  }
}

const raffleReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_RAFFLE_PRODUCTS}${PROMISE_PENDING}`:
      return {...state, raffleProducts: {...state.raffleProducts, data: [], isFetch: true, status_code: 0 }}
    case `${GET_RAFFLE_PRODUCTS}${PROMISE_FULFILLED}`:
      return {...state, raffleProducts: {...state.raffleProducts, data: action.payload.data.raffle_variants, isFetch: false, error:null, status_code: 200 }}
    case `${GET_RAFFLE_PRODUCTS}${PROMISE_REJECTED}`:{
      const { error } = parseError(action.payload);
      return {...state, raffleProducts: {...state.raffleProducts, isFetch: false, error:{ ...error, type: getTypeError(error) },status_code: error.status_code }}
    }
    default: return state
  }
}

export default raffleReducer;
